import Devices from './ui/devices/devices';

export default Devices;
